// InviteRedirect.tsx
import { useGetConfigQuery } from '@diditusa/shared/api/configApi';
import { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import LoadingIndicator from '../../components/LoadingIndicator/loadingIndicator';
import { getErrorMessage } from '@diditusa/shared/api/apiUtils';

const InviteRedirect = () => {
  const { token } = useParams();
  const {
    data: config,
    isLoading: isConfigLoading,
    isError: isConfigError,
    error: configError,
  } = useGetConfigQuery();

  useEffect(() => {
    if (!token || !config) return;

    const stateObj = {
      affiliateToken: token,
    };

    const stateString = btoa(JSON.stringify(stateObj));
    const loginUrl = `${config?.userLoginUrl}&redirect_uri=${window.location.origin}/home`;

    const cognitoUrl = loginUrl + `&state=${stateString}`;
    window.location.href = cognitoUrl;
  }, [token, config]);

  return (
    <>
      <LoadingIndicator isVisible={isConfigLoading} />
      {isConfigError && <p>{getErrorMessage(configError)}</p>}
    </>
  );
};

export default InviteRedirect;
